import React from 'react';
import { PropTypes } from 'prop-types';
import { ExpandableContainer } from '@unite-us/client-utils';

const TimelineEventDetails = ({ eventItems, eventDate }) => (
  <div className={'-mb-12'}>
    <ExpandableContainer
      collapsedHeight="5px"
      id="state-timeline-event-details-expandable-container"
      lessText="Hide details"
      moreText="Show details"
      togglePosition="top-left"
    >
      {eventItems.map((item, index) => (
        <div
          key={`${item.label}-${item.value}-${eventDate}`}
          className={(index === eventItems.length - 1) ? 'mb-4' : 'mb-0'}
        >
          <strong className="text-12px text-dark-grey">
            {item.label}
          </strong>{': '}{item.value}<br />
        </div>
      ))}
    </ExpandableContainer>
  </div>
);

TimelineEventDetails.propTypes = {
  eventItems: PropTypes.object.isRequired,
  eventDate: PropTypes.string.isRequired,
};

export default TimelineEventDetails;
